import req from "../http";

// HCP 人事資料
const hcpInfo = {
  // 依據MatchId 取得 HCP人事資料
  getHcpInfo(matchId) {
    return req("get", `/Recruitment/HCPInfo/${matchId}`);
  },

  // 依據MatchId 取得 HCP人事資料身份別
  getHcpIdentityType(matchId) {
    return req("get", `/Recruitment/HCPInfo/IdentityType/${matchId}`);
  },

  // 更新 HCP人事資料欄位
  postHcpInfo(params) {
    return req("post", "/Recruitment/HCPInfo", params);
  },

  // 匯出 HCP人事資料
  exportHcpInfo(params) {
    return req("post", "/Recruitment/HCPInfo/Export", params, { responseType: "blob" });
  },
};

export default hcpInfo;